import React from 'react';
import { useTranslation } from 'react-i18next';
import './ManifestoSection.scss';

function ManifestoSection() {
  const { t, i18n } = useTranslation();
  const isEn = !i18n.language?.startsWith('zh');

  return (
    <section className={`manifesto ${isEn ? 'manifesto--en' : ''}`}>
      <p className="manifesto__label">{t('home.manifesto.label')}</p>
      <div className="manifesto__quote">
        <p>{t('home.manifesto.quoteLine1')}</p>
        <p>{t('home.manifesto.quoteLine2')}</p>
        <p>{t('home.manifesto.quoteLine3')}</p>
      </div>
      <div className="manifesto__divider" />
    </section>
  );
}

export default ManifestoSection;
